/** Subtle but clearly legible reconstruction disclosure on the live reel / cards. */
import { RECONSTRUCTION_LABEL } from "../../game/disclosure.js";

export function ReconstructionLabel({
  show,
  compact = false,
}: {
  show: boolean;
  compact?: boolean;
}) {
  if (!show) return null;
  return (
    <div
      className={`reconstruction-label${compact ? " compact" : ""}`}
      data-testid="reconstruction-label"
      role="note"
    >
      {RECONSTRUCTION_LABEL}
    </div>
  );
}
